import { useEffect, useState } from 'react';

import { Locale } from 'chaika-enums';

import { OptionType } from '@components/Select';
import { Nullable, Optional } from 'chaika-common-types';
import { entryService } from '@patient/services/entry/entryService';
import { translate } from '@chaika/i18n/helper';
import { EntryTranslation } from '@patient/store/entry/EntryTranslation';
import { getLanguagesTranslation } from '@utils/enumTranslation';
import { store } from '@store';

interface Props {
    confirmedTranslations: EntryTranslation[];
    fromSoap?: boolean;
}

export function useTranslationSelect({ confirmedTranslations, fromSoap }: Props) {
    const {
        viewPort: { isMobileSize },
    } = store;

    const defaultOption: OptionType = {
        value: 'default',
        label: translate('main'),
    };

    const confirmedTranslationOptions: OptionType[] = confirmedTranslations.map(it => ({
        value: it.locale,
        label: getLanguagesTranslation(it.locale),
    }));
    confirmedTranslationOptions.unshift(defaultOption);

    const [selectedValue, setSelectedValue] = useState(confirmedTranslationOptions[0].value);

    useEffect(() => {
        return () => {
            onChange(defaultOption);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function onChange(option: Nullable<OptionType>) {
        if (option) {
            setSelectedValue(option.value);
            const entryLocaleValue = option.value === defaultOption.value ? undefined : option.value;
            await entryService.makeTranslatedEntry(entryLocaleValue as Optional<Locale>, fromSoap);
        }
    }

    return {
        isMobileSize,
        selectedValue,
        confirmedTranslationOptions,
        onChange,
    };
}
